import {
  forwardRef,
  use,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
// import {
//   genTemplateBodyDate,
//   genTemplateBodyText,
// } from "@/components/utils/TableTemplateBodyGenerator";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { ProgressSpinner } from "primereact/progressspinner";
import { differenceInDays, format } from "date-fns";
// import useCheckUser from "@/hooks/useCheckUser";
import { useAPIGetOfferRewardFree } from "../../api/freeproduct/api-get-freeproduct";
import useIsMobile from "../../../../../hooks/useIsMobile";
import OfferRewardFreeFilter from "./offer-reward-free-filter";

const OfferRewardFreeList = forwardRef((props, ref) => {
  const { onClickRowEdit } = props;
  const isMobile = useIsMobile();

  const [listSelected, setListSelected] = useState(null);

  // const { isDeveloper } = useCheckUser();

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  } = useAPIGetOfferRewardFree();

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
    fetchListData: ({ page, take } = {}) => {
      fetchListData({ page: page ?? paging.page, take: take ?? paging.take });
    },
  }));

  // use effect section

  useEffect(() => {
    fetchListData({ page: paging.page, take: paging.take });
  }, []);

  //  custom ui section

  const customerBodyTemplate = (row) => {
    const { data_customer } = row;
    return (
      <div className="col-start-start gap-1">
        <span className="font-semibold text-slate-700">{data_customer?.name}</span>
        <span className="text-xs text-slate-500">{data_customer?.code}</span>
        <span className="text-xs font-semibold text-blue-600">
          BC: {data_customer?.data_bc?.name ?? "-"}
        </span>
      </div>
    );
  };

  const productBodyTemplate = (row) => {
    const { data_product } = row;
    const used = row.usage_sales_item_id !== null && row.usage_sales_item_id !== undefined;
    return (
      <div className="col-start-start gap-1 w-full">
        <div className="row-between-center gap-2 w-full">
          <span className="font-semibold text-slate-700 text-sm">
            {data_product?.name ?? "-"}
          </span>
          {/* <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${used
              ? "bg-green-100 text-green-700 border border-green-300"
              : "bg-slate-100 text-slate-500 border border-slate-300"
              }`}
          >
            {used ? "Used" : "Not Used"}
          </span> */}
        </div>
        {data_product?.code && (
          <span className="text-xs text-slate-500">{data_product.code}</span>
        )}
        {row.quantity > 1 && (
          <span className="text-xs text-slate-400">Qty: {row.quantity}</span>
        )}
      </div>
    );
  };

  const expiredAndUsedBodyTemplate = (row) => {
    const { expired_date, request_expired_date } = row;

    const used =
      row.usage_sales_item_id !== null &&
      row.usage_sales_item_id !== undefined;

    const txDate = row.data_usage_sales_item?.data_sales?.transaction_date;

    if (!expired_date) return "-";

    const today = new Date();
    const expDate = new Date(expired_date);
    const daysLeft = differenceInDays(expDate, today);

    const isExpired = daysLeft < 0;
    const isNear = daysLeft >= 0 && daysLeft <= 30;
    const suppressExpiredStyle = used && isExpired;

    return (
      <div className="col-start-start gap-1">
        {request_expired_date && (
          <span className="text-xs text-blue-500 font-medium">
            Requested: {format(new Date(request_expired_date), "dd MMM yyyy")}
          </span>
        )}

        <span
          className={`text-sm font-semibold ${suppressExpiredStyle
            ? "text-slate-700"
            : isExpired
              ? "text-red-600"
              : isNear
                ? "text-orange-500"
                : "text-slate-700"
            }`}
        >
          {format(expDate, "dd MMM yyyy")}
        </span>

        {!used && (
          <span
            className={`text-xs ${isExpired
              ? "text-red-500"
              : isNear
                ? "text-orange-400"
                : "text-slate-400"
              }`}
          >
            {isExpired
              ? `Expired ${Math.abs(daysLeft)} days ago`
              : daysLeft === 0
                ? "Expires today!"
                : `${daysLeft} days left`}
          </span>
        )}

        {txDate && (
          <span className="text-xs text-slate-400">
            Used: {format(new Date(txDate), "dd MMM yyyy HH:mm")}
          </span>
        )}
      </div>
    );
  };

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          icon={row.id && row.id > 0 ? "pi pi-pencil" : "pi pi-plus"}
          rounded
          severity={row.id && row.id > 0 ? "primary" : "success"}
          className={`${row.id && row.id > 0 ? "bg-indigo-400" : "bg-emerald-400"
            } max-w-[1.65rem] max-h-[1.65rem]`}
          onClick={() => {
            if (onClickRowEdit) onClickRowEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
        {/* {isDeveloper() && ( */}
        {/* <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onClickRowVoid) onClickRowVoid(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        /> */}
        {/* )} */}
      </div>
    );
  };

  // const MobileCard = ({ row }) => {
  //   const nomor = genTemplateBodyText({ row, field: "nomor" });
  //   const tanggal = genTemplateBodyDate({
  //     row,
  //     field: "tanggal",
  //     defaultEmpty: "-",
  //     format: "HH:mm:ss",
  //   });
  //   const masalah = genTemplateBodyText({
  //     row,
  //     field: "data_masalah.deskripsi",
  //     defaultEmpty: "-",
  //   });
  //   const solusi = genTemplateBodyText({
  //     row,
  //     field: "solusi",
  //     defaultEmpty: "-",
  //   });
  //   const unfinishedDetil =
  //     row?.data_open_case_detils?.filter(
  //       (detil) => detil?.verif_karyawan_selesai_id === null
  //     ) ?? [];
  //   const kategoryComponents = (row.data_kategoris ?? []).map(
  //     (kategori, idx) => {
  //       const classListrik =
  //         "border-1 px-2 rounded-md border-blue-400 bg-blue-50 text-blue-700";
  //       const classMesin =
  //         "border-1 px-2 rounded-md border-green-400 bg-green-50 text-green-700";
  //       const classUmum =
  //         "border-1 px-2 rounded-md border-gray-400 bg-gray-200 text-gray-700";

  //       let className = "";
  //       if (kategori?.kode.toLowerCase() === "b") {
  //         className = classListrik;
  //       } else if (kategori?.kode.toLowerCase() === "a") {
  //         className = classMesin;
  //       } else {
  //         className = classUmum;
  //       }

  //       return (
  //         <span key={idx} className={className}>
  //           {kategori?.kode ?? "-"}
  //         </span>
  //       );
  //     }
  //   );

  //   let namaMesin = row?.data_mesin?.nama || "-";
  //   let kodeMesin = row?.data_mesin?.kode || "-";
  //   const subMesinMerek = row?.data_mesin_bagian?.merek || "-";

  //   return (
  //     <div className="bg-white border border-slate-300 rounded-xl px-4 py-3 flex flex-col gap-2">
  //       {/* Header Row */}
  //       <div className="flex justify-between items-start">
  //         <div>
  //           <div className="text-sm text-slate-500">Nomor Case</div>
  //           <div className="font-bold text-slate-800 text-base leading-tight">
  //             {nomor}
  //           </div>
  //           <div className="text-sm text-slate-400 mt-0.5">{tanggal}</div>
  //         </div>
  //         <div className="col-start-center gap-2">
  //           <Button
  //             icon={<i className="pi pi-pencil !text-xs"></i>}
  //             rounded
  //             className="bg-indigo-500 text-white !w-8 !h-8"
  //             onClick={() => onClickRowEdit?.(row)}
  //           />
  //           {unfinishedDetil.length > 0 && (
  //             <div className="flex items-center">
  //               <i
  //                 className={`pi pi-circle-fill !text-[0.7rem] text-rose-400 animate-pulse`}
  //               />
  //             </div>
  //           )}
  //         </div>
  //       </div>

  //       {/* Divider */}
  //       <div className="border-t border-slate-200 my-2"></div>

  //       <div className="col-start-start">
  //         <div className="row-center-center gap-2 text-sm">
  //           <i className="pi pi-cog !text-sm !hidden lg:!flex" />
  //           <div className="col-start-start">
  //             <span className="font-semibold">{kodeMesin}</span>
  //             <span className="font-semibold">{namaMesin}</span>
  //           </div>
  //         </div>
  //         <div className="row-center-start text-gray-500 gap-1 text-center">
  //           <span>{subMesinMerek}</span>
  //           {/* <span>{subMesinModel}</span> */}
  //         </div>
  //       </div>

  //       {/* Divider */}
  //       <div className="border-t border-slate-200 my-2"></div>

  //       {/* Content Section */}
  //       <div className="flex flex-col gap-1">
  //         {kategoryComponents && (
  //           <div className="flex flex-wrap gap-1">{kategoryComponents}</div>
  //         )}
  //         <div className="text-[0.9rem] font-semibold text-slate-700 leading-snug">
  //           Masalah: {masalah}
  //         </div>
  //         <div className="leading-snug text-sm text-stone-600">
  //           Solusi: {solusi}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <div className="row-start-start w-full gap-4">
        <OfferRewardFreeFilter
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onClickRefresh={handleOnClickRefresh}
        />
      </div>
      {/* table section */}
      <div className="col-start-center w-full gap-3">
        <div className="row-between-center w-full">
          {isMobile && (
            <Button
              icon="pi pi-refresh"
              outlined
              rounded
              onClick={() => {
                if (handleOnClickRefresh) handleOnClickRefresh();
              }}
            />
          )}
        </div>
        {isMobile ? (
          <div className="flex flex-col gap-3 w-full">
            {listData?.length > 0 ? (
              <>
                {/* {listData.map((row, idx) => (
                  <MobileCard key={idx} row={row} />
                ))} */}
              </>
            ) : (
              <div className="text-center text-gray-500 py-10">
                Tidak ada data.
              </div>
            )}
            {loading && (
              <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/10">
                <ProgressSpinner />
              </div>
            )}
          </div>
        ) : (
          <>
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              value={listData}
            // selection={listSelected}
            // onSelectionChange={(e) => setListSelected(e.value)}
            >
              {/* <Column selectionMode="single" headerStyle={{ width: "3rem" }} hidden/> */}
              <Column
                field="no"
                header="#"
                className="text-center"
                headerClassName="w-[1rem]"
                alignHeader="center"
                bodyStyle={{ textAlign: "center" }}
              />
              <Column
                field=""
                header="Action"
                alignHeader="center"
                headerClassName="w-[4rem]"
                body={actionBodyTemplate}
              />
              <Column
                field="data_customer.name"
                header="Customer"
                headerClassName="w-[15rem]"
                body={customerBodyTemplate}
              />
              <Column
                field="data_product.name"
                header="Package"
                body={productBodyTemplate}
              />
              <Column
                field="expired_date"
                header="Expired Date"
                headerClassName="w-[11rem]"
                body={expiredAndUsedBodyTemplate}
              />
            </DataTable>
          </>
        )}
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
          template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        />
      </div>
    </div>
  );
});

export default OfferRewardFreeList;
